import { useMemo, useState } from "react";
import { Card, SectionHeader, TextInput } from "../../components/lib";
import { TabBar, ListRow } from "../../components/lib.overlay";
import { WS_FILES, WsFile } from "../../mocks/workspaceData";

export default function Files() {
  const [tab, setTab] = useState<WsFile["kind"] | "all">("all");
  const [q, setQ] = useState("");
  const filtered = useMemo(() => WS_FILES.filter((f) =>
    (tab === "all" || f.kind === tab) &&
    (!q || f.name.toLowerCase().includes(q.toLowerCase()) || f.tags.join(" ").toLowerCase().includes(q.toLowerCase())),
  ), [tab, q]);

  return (
    <div className="space-y-6" data-testid="ws-files">
      <Card testId="ws-f-filters">
        <TextInput value={q} onChange={setQ} placeholder="Search files by name or tag…" testId="ws-f-search" />
        <div className="mt-4 overflow-x-auto">
          <TabBar<WsFile["kind"] | "all">
            testId="ws-f-tabs"
            active={tab}
            onChange={setTab}
            tabs={[
              { key: "all",        label: "All" },
              { key: "brief",      label: "Brief" },
              { key: "formula",    label: "Formula" },
              { key: "coa",        label: "CoA" },
              { key: "contract",   label: "Contract" },
              { key: "invoice",    label: "Invoice" },
              { key: "creative",   label: "Creative" },
              { key: "regulatory", label: "Regulatory" },
              { key: "other",      label: "Other" },
            ]}
          />
        </div>
      </Card>

      <Card padded={false} testId="ws-f-list-card">
        <div className="p-5" style={{ borderBottom: "1px solid var(--ph-border-subtle)" }}>
          <SectionHeader eyebrow="Files" title={`${filtered.length} file${filtered.length === 1 ? "" : "s"}`} />
        </div>
        <div className="p-2">
          {filtered.map((f) => (
            <ListRow key={f.id} testId={`ws-fl-${f.id}`}
              label={<span>{f.name}</span>}
              sublabel={<>{f.kind} · {f.owner} · updated {f.updatedRelative} · {f.tags.join(", ")}</>}
              trailing={<span className="text-sm tabular-nums" style={{ color: "var(--ph-ink-muted)" }}>{f.size}</span>}
            />
          ))}
        </div>
      </Card>
    </div>
  );
}
